module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_kimono@2x-1b3a0d9da7d86a63be7f3649f36ec966.webp";